/**
 * Notification keys — the source of truth for all notification types.
 * Titles and descriptions are stored in translations (en.json / nl.json)
 * under keys: Notification.<key>.title and Notification.<key>.description
 */
export const NOTIFICATION_KEYS = {
  WELCOME: 'welcome',
  FIRST_LISTING: 'first_listing',
  FEATURED: 'featured',
};

/**
 * Creates a notification object to store in user publicData.
 * Only the key + metadata is stored — display strings come from translations.
 *
 * @param {string} notification_key - one of NOTIFICATION_KEYS
 * @param {Object} [meta={}] - optional extra data (e.g. txId, transactionRole, listingTitle)
 * @returns {Object} notification record
 */
export const createNotification = (notification_key, meta = {}) => {
  const now = new Date();
  return {
    id: `notif_${notification_key}_${Date.now()}`,
    notification_key,
    isRead: false,
    readAt: null,
    createdAt: now.toISOString(),
    meta,
  };
};
